/**
 * Pure formatters for the shadow-comparison table, split out so the
 * defensive date parsing is unit-testable without rendering the table.
 * `createdAt` arrives typed as `any` (the `DateTime` scalar has no override
 * for internal/frontend), so this reader narrows at runtime before
 * constructing a `Date` rather than trusting the backend's shape.
 */

/**
 * Formats a shadow-comparison row timestamp, or "--" when the value is not a
 * parseable date (absent, malformed, or of an unexpected type).
 */
export const formatShadowTimestamp = (value: unknown): string => {
  if (
    typeof value !== "string" &&
    typeof value !== "number" &&
    !(value instanceof Date)
  ) {
    return "--";
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "--" : date.toLocaleString();
};
